import React from 'react';
import { Redirect, Route, type RouteProps } from 'react-router-dom';
import { useAuth } from '../../application/use-cases/auth/AuthContext';

interface AdminRouteProps extends Omit<RouteProps, 'render' | 'component' | 'children'> {
  path: string;
  children: React.ReactNode;
}

// Defensa en profundidad: el backend ya rechaza /api/admin/* con 403 si
// is_admin es false, esto solo evita que alguien sin admin vea la pantalla.
// Reenvía todas las props a Route — en especial computedMatch, que
// IonRouterOutlet le pasa a cada vista para que siga renderizando su propia
// ruta durante la transición. Sin eso, la pantalla que se va se compara con
// la URL nueva, deja de coincidir y queda en blanco a mitad de la animación.
const AdminRoute: React.FC<AdminRouteProps> = ({ children, ...routeProps }) => {
  const { user } = useAuth();
  return <Route {...routeProps} render={() => (user?.isAdmin ? children : <Redirect to="/app/dashboard" />)} />;
};

export default AdminRoute;
